import * as React from 'react';

import { 
    Box, 
    Typography, 
    CircularProgress,
    TextField,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Button,
    Alert
} from '@mui/material';

import { Candid } from '../../../../controllers';

export default function Main({handleChange}){

    const loading = React.useRef(false);

    const [data, setData] = React.useState([]);
    const [input, setInput] = React.useState('');

    const handleInput = async(e) => {
        if(e.target.value.length > 5){
            alert('Max characters for Case ID');
            return;
        }
        setInput(e.target.value.toUpperCase());
    }

    const handleSubmit = async(e) => {
        e.preventDefault();

        if(input.length != 5){
            alert('Invalid Case ID. Is missing characters');
            setData([]);
            return;
        }
        
        if(loading.current){
            return;
        }

        loading.current = true;
        await handleLoading();
        loading.current = false;
    }

    const handleLoading = async() => {
        const response = await Candid.GetHistory(input);

        if(response === undefined){
            alert('Response Error. \nPlease, try again');
            console.log(response.error);
            setData([]);
            return;
        }

        if(!response.success || !response.found){
            alert('Case not found in records. \nPlease, check your input');
            setData([]);
            return;
        }

        setData(response.result);
        
        loading.current = false;
    }

    return(
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width:'100%',
            }}
        >
            <Typography variant='h5'>Candid History</Typography>
            <Typography >Check Candid orders tracking history</Typography>

            <Box
                component='form'
                onSubmit={handleSubmit}
            >
                <TextField 
                    placeholder='Enter Case ID'
                    fullWidth
                    value = {input}
                    onChange={handleInput}
                />
            </Box>
            
            <br/>

            <Divider sx={{minWidth:'100%'}}></Divider>

            <TableContainer sx={{mt:4, mb:2}}>
                <Table>
                     <TableBody>
                        
                        <TableRow
                            sx={{ borderBottom : 2, borderColor : 'gray'}}
                        >
                            <TableCell align='center' width={'25%'}>
                                <Typography variant='button'> Date </Typography>
                            </TableCell>

                            <TableCell align='center' width={'25%'}>
                                <Typography variant='button'> Area </Typography>
                            </TableCell>
                            <TableCell align='center' width={'25%'}>
                                <Typography variant='button'> DHR Amount</Typography>
                            </TableCell>
                            <TableCell align='center' width={'25%'}>
                                <Typography variant='button'> Scanned Amount</Typography>
                            </TableCell>
                        </TableRow>

                        {data != undefined && data.map( x => (
                            <TableRow
                                sx={{ borderBottom : 2, borderColor : 'lightgray'}}
                            >
                                <TableCell align='center' width={'25%'}>
                                    {new Date(x.date_create).toLocaleDateString()}
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    width={'25%'}
                                    sx={{ border : 1, borderColor : 'lightgray', borderBlockStart: 0}}
                                >
                                    {x.data_general.area.name}
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    width={'25%'}
                                    sx={{ border : 1, borderColor : 'lightgray', borderBlockStart: 0}}
                                >
                                    {x.data_general.counter.dhr}
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    width={'25%'}
                                >
                                    {x.data_general.counter.counter}
                                </TableCell>
                            </TableRow>
                        ))}

                    </TableBody>
                </Table>
            </TableContainer>

            {loading.current && (
                <Box
                    sx={{
                        width:'100%',
                        display:'flex',
                        flexDirection:'column',
                        alignItems:'center'
                    }}
                >
                    Loading Data
                    <CircularProgress />
                </Box>
            )}

        </Box>
    );
}